module.exports = "<div style=\"background: #ffffff\">\n  <div class=\"row page-layout-header ml-0\">\n    <ul class=\"nav navbar-toolbar\">\n      <li *ngFor=\"let expertTab of expertTabList\" [class]=\"expertTab.id == currentTab ? 'nav-active' : 'nav-item'\">\n        <a (click)=\"onChangeTab(expertTab.id)\" class=\"nav-link\"  href=\"javascript:void(0)\"><span>{{ expertTab.title }}</span>\n        </a>\n      </li>\n    </ul>\n  </div>\n  <router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/expert/expert.component.html
// module id = ./src/app/pages/admin/icontact/setting/expert/expert.component.html
// module chunks = main